import { Navigate, useLocation } from 'react-router-dom'

/** Alte Lager-URLs (Plan 2026-10-23 S3c): Ziel wechselt, Query und Anker bleiben (?run=, ?reihe=, ?tab=). */
export function Weiterleitung({ to }: { to: string }) {
  const { search, hash } = useLocation()
  return <Navigate to={{ pathname: to, search, hash }} replace />
}
